import { Alert, Button } from "reactstrap";

import { Drawer } from "../../components/Drawer";
import PropTypes from "prop-types";
import React from "react";

class CompanyModal extends React.Component {
  constructor(props) {
    super(props);
    this.name = React.createRef();
  }

  isValidForm() {
    return this.name.current.checkValidity();
  }

  handleSubmit(event) {
    if (this.isValidForm()) {
      event.preventDefault();
      const company = {
        id: this.props.company.id,
        name: this.name.current.value,
      };
      this.props.onSubmit(company);
    }
  }

  render() {
    const isUpdate = !!this.props.company.id;
    const footer = (
      <>
        <Button color="secondary" onClick={() => this.props.onClose()}>
          Cancel
        </Button>
        <Button
          color="primary"
          className="btn"
          type="submit"
          form="companyForm"
          onClick={(event) => this.handleSubmit(event)}
        >
          {isUpdate ? "Update" : "Create"}
        </Button>
      </>
    );

    return (
      <Drawer
        isOpen={this.props.isOpen}
        onClose={() => this.props.onClose()}
        title={`${isUpdate ? "Update" : "Create"} company`}
        footer={footer}
      >
        {this.props.alert !== "" ? (
          <Alert color="danger">{this.props.alert}</Alert>
        ) : null}
        <form id="companyForm">
          <div className="mb-3">
            <label className="col-form-label">Name *</label>
            <input
              className="form-control"
              defaultValue={this.props.company.name}
              type="text"
              ref={this.name}
              required
            />
          </div>
        </form>
      </Drawer>
    );
  }
}

CompanyModal.propTypes = {
  alert: PropTypes.string.isRequired,
  company: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default CompanyModal;
